import Footer from "components/Footers/Footer";
import Navbar from "components/Navbars/IndexNavbar";
import Swal from "sweetalert2";
import React, { useState, useEffect } from "react";
import "react-block-ui/style.css";
import BASE_URL from "components/BaseUrl/apiConfig";

const UserExpenses = () => {
  //userExpenses
  const [loading, setLoading] = useState(false); // Add this line to define 'loading'
  const [currency, setCurrency] = useState("");
  const [expenseData, setExpenseData] = useState({
    expenseDescritions: [],
    expenses: [],
    totalDebited: 0,
    totalCreated: 0,
    availableBalance: "",
  });

  const urlSearchParams = new URLSearchParams(window.location.search);
  const userKey = urlSearchParams.get("UserKey");

  useEffect(() => {
    fetchCurrencyData();
    fetchData();
  }, []); // Fetch data on component mount

  const fetchCurrencyData = async () => {
    try {
      const apirul1 = `${BASE_URL}/api/Users/GetCurrencyByGuiId1?guiId=${userKey}`;
      const response = await fetch(apirul1);
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const data = await response.text(); // Parse response JSON
      setCurrency(data); // Assuming 'currency' is a property of the response
      console.log(data); // Log the response data
    } catch (error) {
      console.error("Error fetching currency data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);

      if (!userKey) {
        // Show an error message if UserKey is not present in the URL
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "UserKey not found in the URL.",
          showConfirmButton: true,
        });
        return;
      }

      const apiUrl = `${BASE_URL}/api/Expense/GetExpensesUserKey?UserKey=${userKey}`;
      const response = await fetch(apiUrl);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      setExpenseData(data);
    } catch (error) {
      console.error("Error fetching data:", error);
      // Show an error message if there's an issue fetching data
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to fetch expense data. Please try again later.",
        showConfirmButton: true,
      });
    }
  };

  const formatPayDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return ` ${day}/${month}/${year}`;
  };

  // Check if availableBalance is greater than 0
  const isPositiveBalance = expenseData.availableBalance > 0;

  // Set the color dynamically based on the condition
  const balanceColor = isPositiveBalance ? "rgb(0, 0, 255)" : "red";

  return (
    <>
      <Navbar />
      <div className="cust-div">
        <div className="container mx-auto mt-4 p-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-2xl uppercase font-bold">
              Expenses(<span>{currency}</span>)
            </h1>
          </div>
          <div className="flex items-center mb-4 text-lg">
            <div className="flex-shrink-0">
              <span className="mr-4">
                <strong>Balance: </strong>
                <span style={{ color: balanceColor }}>
                  {expenseData.availableBalance}
                </span>{" "}
                |
              </span>
              <span className="mr-4">
                <strong>Credited:</strong>{" "}
                <span style={{ color: "rgb(50, 205, 50)" }}>
                  {expenseData.totalCreated}
                </span>{" "}
                |
              </span>
              <span className="mr-4">
                <strong>Debited:</strong>{" "}
                <span style={{ color: "orange" }}>
                  {expenseData.totalDebited}
                </span>
              </span>
            </div>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full min-w-full border cust-table">
              <thead>
                <tr className="border-b bg-lightBlue-500 text-white">
                  <th className="cell py-2 px-4 font-bold text-left">Type</th>
                  <th className="cell py-2 px-4 font-bold text-left">
                    Expense Description
                  </th>
                  <th className="cell py-2 px-4 font-bold text-left">
                    Amount({currency})
                  </th>
                  <th className="cell py-2 px-4 font-bold text-left">Date</th>
                  <th className="cell py-2 px-4 font-bold text-left">By</th>
                  <th className="cell py-2 px-4 font-bold text-left">
                    Balance
                  </th>
                </tr>
              </thead>
              <tbody>
                {expenseData &&
                expenseData.expenses &&
                expenseData.expenses.length > 0 ? (
                  expenseData.expenses.map((expense) => (
                    <tr
                      key={expense.expenseId}
                      className={`cust-row`}
                      style={{
                        backgroundColor:
                          expense.expenseTypeId === "Cr."
                            ? "#D5F5E3 "
                            : "#FADBD8",
                      }}
                    >
                      {/* <td className="cell py-1 px-4  text-left">{expense.expenseDescType}({expense.expenseTypeId})</td> */}
                      <td className="cell py-1 px-4 text-left">
                        {expense.expenseTypeId === "Cr." ? (
                          <i className="fas fa-arrow-up text-emerald-500 mr-1 "></i>
                        ) : (
                          <i className="fas fa-arrow-down text-red-500 mr-1"></i>
                        )}

                        {expense.expenseDescType}
                      </td>
                      <td className="cell py-1 px-4  text-left">
                        {expense.description}
                      </td>
                      <td className="cell py-1 px-4  text-left">
                        {expense.expenses}
                      </td>
                      <td className="cell py-1 px-4  text-left">
                        {formatPayDate(expense.date)}
                      </td>
                      <td className="cell py-1 px-4  text-left">
                        {expense.userName}
                      </td>
                      <td className="cell py-1 px-4  text-left">
                        {expense.balance}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="6"
                      className="text-center text-lg text-gray-900 mt-4"
                    >
                      No data found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default UserExpenses;
